module.exports = __webpack_public_path__ + "img/team-14.ec4cb618.jpg";